import { render, staticRenderFns } from "./PlanDetail.vue?vue&type=template&id=00cd1b1c&scoped=true&"
import script from "./PlanDetail.vue?vue&type=script&lang=js&"
export * from "./PlanDetail.vue?vue&type=script&lang=js&"
import style0 from "./PlanDetail.vue?vue&type=style&index=0&id=00cd1b1c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cd1b1c",
  null
  
)

export default component.exports